/* ==================================================
   AUROS CUSTOM JS
   Funcionalidades personalizadas Shopify
   Autor: William David Vivas Rubio
   ================================================== */

(function () {
  "use strict";

  if (window.AUROS_CUSTOM_JS_LOADED) return;
  window.AUROS_CUSTOM_JS_LOADED = true;

  var AUROS = (window.AUROS = window.AUROS || {});
  var ALLOWED_PURCHASE_FLOWS = [
    "DIRECTO",
    "EDITOR",
    "PDF",
    "EDITOR_PDF",
    "ASESORIA",
    "COTIZACION"
  ];

  function isAllowedPurchaseFlow(flow) {
    return ALLOWED_PURCHASE_FLOWS.indexOf(flow) !== -1;
  }

  function normalizePurchaseFlow(value) {
    var flow =
      typeof value === "string"
        ? value.trim().toUpperCase()
        : "";

    return isAllowedPurchaseFlow(flow) ? flow : "";
  }

  function toBoolean(value) {
    return value === true;
  }

  function freezeObject(object) {
    if (
      !object ||
      typeof object !== "object" ||
      Object.isFrozen(object)
    ) {
      return object;
    }

    Object.keys(object).forEach(function (key) {
      freezeObject(object[key]);
    });

    return Object.freeze(object);
  }

  function readProductFlowContext() {
    var contextElement = document.getElementById(
      "auros-product-flow-context"
    );

    if (!contextElement) {
      return null;
    }

    try {
      var rawContext = JSON.parse(
        contextElement.textContent || "{}"
      );

      if (!rawContext || typeof rawContext !== "object") {
        return null;
      }

      var rawProduct =
        rawContext.product &&
        typeof rawContext.product === "object"
          ? rawContext.product
          : {};

      var rawPurchase =
        rawContext.purchase &&
        typeof rawContext.purchase === "object"
          ? rawContext.purchase
          : {};

      var rawExistingSignals =
        rawContext.existingSignals &&
        typeof rawContext.existingSignals === "object"
          ? rawContext.existingSignals
          : {};

      var flow = normalizePurchaseFlow(
        rawPurchase.flow
      );

      var configured =
        flow !== "" &&
        toBoolean(rawPurchase.configured);

      /*
        Los booleanos operativos se derivan siempre del flujo maestro.
        No se confía ciegamente en valores duplicados del JSON para evitar
        contradicciones entre el metacampo y cualquier dato secundario.
      */
      var normalizedContext = {
        schemaVersion:
          Number(rawContext.schemaVersion) || 1,

        source:
          typeof rawContext.source === "string"
            ? rawContext.source
            : "shopify",

        product: {
          id:
            rawProduct.id !== undefined &&
            rawProduct.id !== null
              ? String(rawProduct.id)
              : "",
          handle:
            typeof rawProduct.handle === "string"
              ? rawProduct.handle
              : "",
          title:
            typeof rawProduct.title === "string"
              ? rawProduct.title
              : "",
          url:
            typeof rawProduct.url === "string"
              ? rawProduct.url
              : ""
        },

        purchase: {
          flow: flow,
          configured: configured,

          /*
            Semántica operativa:
            - "requiresEditor" y "requiresFile" significan obligación exclusiva.
            - EDITOR_PDF no obliga a usar ambos; obliga a elegir uno de los dos.
            - "allowsEditor" / "allowsFile" expresan las rutas disponibles.
          */
          directPurchase: flow === "DIRECTO",
          requiresPreparation:
            flow === "EDITOR" ||
            flow === "PDF" ||
            flow === "EDITOR_PDF",
          requiresEditor: flow === "EDITOR",
          requiresFile: flow === "PDF",
          requiresEditorOrFileChoice:
            flow === "EDITOR_PDF",
          allowsEditor:
            flow === "EDITOR" ||
            flow === "EDITOR_PDF",
          allowsFile:
            flow === "PDF" ||
            flow === "EDITOR_PDF",
          requiresAssistance: flow === "ASESORIA",
          requiresQuote: flow === "COTIZACION"
        },

        existingSignals: {
          designUploadMode:
            typeof rawExistingSignals.designUploadMode ===
            "string"
              ? rawExistingSignals.designUploadMode
                  .trim()
                  .toLowerCase()
              : "",
          whatsappPurchase:
            toBoolean(
              rawExistingSignals.whatsappPurchase
            )
        }
      };

      return freezeObject(normalizedContext);
    } catch (error) {
      console.error(
        "AUROS: no fue posible leer el contexto estructurado del producto.",
        error
      );

      return null;
    }
  }

  function installPublicApi(context) {
    AUROS.context = AUROS.context || {};

    AUROS.context.product =
      context ? context.product : null;

    AUROS.context.purchase =
      context ? context.purchase : null;

    AUROS.context.existingSignals =
      context ? context.existingSignals : null;

    AUROS.context.productFlow = context;

    AUROS.getProductFlowContext = function () {
      return AUROS.context.productFlow || null;
    };

    AUROS.getPurchaseFlow = function () {
      return AUROS.context.purchase
        ? AUROS.context.purchase.flow
        : "";
    };

    AUROS.hasConfiguredPurchaseFlow =
      function () {
        return Boolean(
          AUROS.context.purchase &&
          AUROS.context.purchase.configured
        );
      };

    AUROS.isPurchaseFlow = function (flow) {
      var normalizedFlow =
        normalizePurchaseFlow(flow);

      return (
        normalizedFlow !== "" &&
        AUROS.getPurchaseFlow() ===
          normalizedFlow
      );
    };

    AUROS.isDirectPurchase = function () {
      return AUROS.isPurchaseFlow("DIRECTO");
    };

    AUROS.requiresEditor = function () {
      return AUROS.isPurchaseFlow("EDITOR");
    };

    AUROS.requiresFile = function () {
      return AUROS.isPurchaseFlow("PDF");
    };

    AUROS.requiresPreparation = function () {
      return Boolean(
        AUROS.context.purchase &&
        AUROS.context.purchase.requiresPreparation
      );
    };

    AUROS.requiresEditorOrFileChoice = function () {
      return AUROS.isPurchaseFlow("EDITOR_PDF");
    };

    AUROS.allowsEditor = function () {
      return Boolean(
        AUROS.context.purchase &&
        AUROS.context.purchase.allowsEditor
      );
    };

    AUROS.allowsFile = function () {
      return Boolean(
        AUROS.context.purchase &&
        AUROS.context.purchase.allowsFile
      );
    };

    AUROS.requiresAssistance = function () {
      return AUROS.isPurchaseFlow("ASESORIA");
    };

    AUROS.requiresQuote = function () {
      return AUROS.isPurchaseFlow("COTIZACION");
    };
  }

  function publishReadyEvent(context) {
    if (!context) {
      return;
    }

    window.dispatchEvent(
      new CustomEvent(
        "auros:product-flow-ready",
        {
          detail: context
        }
      )
    );
  }

  /*
    ==================================================
    AUROS WEBMCP · CAPA 1 · SOLO LECTURA
    ==================================================

    Objetivo:
    Exponer a agentes compatibles con WebMCP la ruta comercial canónica
    del producto actual sin modificar carrito, navegación, cliente,
    Printbox, formularios ni ningún otro estado del storefront.

    Esta herramienta complementa las herramientas WebMCP nativas de
    Shopify. No las reemplaza ni duplica.
  */

  function getPurchaseGuidance(flow) {
    switch (flow) {
      case "DIRECTO":
        return {
          nextAction: "ADD_TO_CART",
          message:
            "Este producto admite compra directa."
        };

      case "EDITOR":
        return {
          nextAction: "OPEN_EDITOR",
          message:
            "Este producto debe personalizarse en el editor AUROS antes de completar la compra."
        };

      case "PDF":
        return {
          nextAction: "UPLOAD_PDF",
          message:
            "Este producto requiere cargar un archivo PDF antes de completar la compra."
        };

      case "EDITOR_PDF":
        return {
          nextAction: "CHOOSE_EDITOR_OR_PDF",
          message:
            "Este producto requiere preparar el diseño antes de completar la compra. El cliente puede personalizarlo en el editor AUROS o subir un archivo PDF."
        };

      case "ASESORIA":
        return {
          nextAction: "REQUEST_ASSISTANCE",
          message:
            "Este producto se compra con acompañamiento de un asesor AUROS."
        };

      case "COTIZACION":
        return {
          nextAction: "REQUEST_QUOTE",
          message:
            "Este producto requiere cotización antes de continuar con la compra."
        };

      default:
        return {
          nextAction: "UNCONFIGURED",
          message:
            "El producto no tiene una ruta comercial AUROS configurada."
        };
    }
  }

  function buildWebMcpPurchasePayload() {
    var context =
      AUROS.getProductFlowContext();

    if (!context) {
      return {
        ok: false,
        reason: "NO_PRODUCT_CONTEXT"
      };
    }

    var flow =
      context.purchase &&
      context.purchase.flow
        ? context.purchase.flow
        : "";

    var guidance =
      getPurchaseGuidance(flow);

    return {
      ok: true,
      schemaVersion: context.schemaVersion,
      source: "auros-shopify",
      product: {
        id: context.product.id,
        handle: context.product.handle,
        title: context.product.title,
        url: context.product.url
      },
      purchase: {
        flow: flow,
        configured:
          context.purchase.configured,
        nextAction:
          guidance.nextAction,
        message:
          guidance.message,
        directPurchase:
          context.purchase.directPurchase,
        requiresPreparation:
          context.purchase.requiresPreparation,
        requiresEditor:
          context.purchase.requiresEditor,
        requiresFile:
          context.purchase.requiresFile,
        requiresEditorOrFileChoice:
          context.purchase.requiresEditorOrFileChoice,
        allowsEditor:
          context.purchase.allowsEditor,
        allowsFile:
          context.purchase.allowsFile,
        requiresAssistance:
          context.purchase.requiresAssistance,
        requiresQuote:
          context.purchase.requiresQuote
      }
    };
  }

  function installWebMcpStatusApi() {
    AUROS.webMcp = AUROS.webMcp || {
      supported: false,
      purchaseContextRegistered: false,
      registrationStatus: "not_started",
      lastError: null,
      invocationCount: 0,
      lastInvocationAt: null,
      lastInvocationFlow: null
    };

    AUROS.getWebMcpStatus = function () {
      return {
        supported:
          AUROS.webMcp.supported,
        purchaseContextRegistered:
          AUROS.webMcp
            .purchaseContextRegistered,
        registrationStatus:
          AUROS.webMcp.registrationStatus,
        lastError:
          AUROS.webMcp.lastError,
        invocationCount:
          AUROS.webMcp.invocationCount,
        lastInvocationAt:
          AUROS.webMcp.lastInvocationAt,
        lastInvocationFlow:
          AUROS.webMcp.lastInvocationFlow
      };
    };

    AUROS.resetWebMcpDiagnostics = function () {
      AUROS.webMcp.invocationCount = 0;
      AUROS.webMcp.lastInvocationAt = null;
      AUROS.webMcp.lastInvocationFlow = null;

      return AUROS.getWebMcpStatus();
    };
  }

  function publishWebMcpReadyEvent() {
    window.dispatchEvent(
      new CustomEvent("auros:webmcp-ready", {
        detail: AUROS.getWebMcpStatus()
      })
    );
  }

  async function registerPurchaseContextTool() {
    installWebMcpStatusApi();

    /*
      WebMCP es una mejora progresiva.
      Si el navegador no ofrece la API, AUROS sigue funcionando exactamente
      igual que antes y no se genera ningún error.
    */
    if (
      !document.modelContext ||
      typeof document.modelContext.registerTool !==
        "function"
    ) {
      AUROS.webMcp.supported = false;
      AUROS.webMcp.registrationStatus =
        "unsupported";

      return false;
    }

    AUROS.webMcp.supported = true;

    /*
      Solo se registra en una página donde realmente existe contexto
      estructurado de producto. Así evitamos herramientas irrelevantes en
      Home, colecciones, políticas y otras páginas.
    */
    if (!AUROS.getProductFlowContext()) {
      AUROS.webMcp.registrationStatus =
        "no_product_context";

      return false;
    }

    if (
      AUROS.webMcp.purchaseContextRegistered
    ) {
      return true;
    }

    AUROS.webMcp.registrationStatus =
      "registering";
    AUROS.webMcp.lastError = null;

    try {
      await document.modelContext.registerTool({
        name: "get_auros_purchase_context",

        description:
          "Returns the current AUROS product's canonical purchase route and required next step. Use it to determine whether the shopper should buy directly, personalize in the editor, upload a PDF, choose between editor or PDF, request assistance, or request a quote. Read-only and does not modify cart, navigation, customer data, or page state.",

        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false
        },

        annotations: {
          readOnlyHint: true,
          untrustedContentHint: false
        },

        execute: async function () {
          /*
            La salida se construye exclusivamente con el contexto validado
            de Shopify/AUROS y textos fijos definidos en este mismo asset.

            El diagnóstico siguiente no modifica carrito, navegación,
            Printbox, formularios ni datos del cliente. Solo registra en
            memoria local de la página que esta herramienta fue invocada.
          */
          var payload =
            buildWebMcpPurchasePayload();

          AUROS.webMcp.invocationCount += 1;
          AUROS.webMcp.lastInvocationAt =
            new Date().toISOString();
          AUROS.webMcp.lastInvocationFlow =
            payload &&
            payload.purchase &&
            payload.purchase.flow
              ? payload.purchase.flow
              : null;

          window.dispatchEvent(
            new CustomEvent(
              "auros:webmcp-tool-invoked",
              {
                detail: {
                  name:
                    "get_auros_purchase_context",
                  invocationCount:
                    AUROS.webMcp.invocationCount,
                  invokedAt:
                    AUROS.webMcp.lastInvocationAt,
                  purchaseFlow:
                    AUROS.webMcp
                      .lastInvocationFlow
                }
              }
            )
          );

          return JSON.stringify(payload);
        }
      });

      AUROS.webMcp
        .purchaseContextRegistered = true;
      AUROS.webMcp.registrationStatus =
        "registered";

      publishWebMcpReadyEvent();

      return true;
    } catch (error) {
      AUROS.webMcp
        .purchaseContextRegistered = false;
      AUROS.webMcp.registrationStatus =
        "error";
      AUROS.webMcp.lastError =
        error && error.message
          ? String(error.message)
          : "Unknown WebMCP registration error";

      console.warn(
        "AUROS: no fue posible registrar la herramienta WebMCP de contexto de compra.",
        error
      );

      return false;
    }
  }


  /*
    ==================================================
    AUROS SCROLL PROGRESS · HEADER STACK
    ==================================================

    Indicador global de progreso de lectura:
    - vive sobre el borde inferior del stack fijo;
    - en Home queda debajo del navbar porque no existe breadcrumb;
    - en páginas internas queda debajo del breadcrumb;
    - usa requestAnimationFrame para agrupar actualizaciones visuales;
    - el listener de scroll es pasivo;
    - ResizeObserver mantiene el cálculo correcto cuando cambia la altura
      del documento por imágenes, secciones o contenido dinámico;
    - responde a los eventos del Theme Editor de Shopify sin bloquear
      ninguna interacción del storefront.
  */

  function initializeScrollProgress() {
    var stack = document.querySelector(
      "[data-auros-site-header-stack]"
    );

    if (!stack) {
      return;
    }

    var ticking = false;
    var lastProgress = -1;
    var resizeObserver = null;

    function measureProgress() {
      ticking = false;

      var root = document.documentElement;
      var body = document.body;

      var scrollTop = Math.max(
        0,
        window.scrollY ||
          root.scrollTop ||
          (body ? body.scrollTop : 0) ||
          0
      );

      var scrollHeight = Math.max(
        root.scrollHeight,
        root.offsetHeight,
        root.clientHeight,
        body ? body.scrollHeight : 0,
        body ? body.offsetHeight : 0
      );

      var viewportHeight =
        window.innerHeight ||
        root.clientHeight ||
        0;

      var maxScroll = Math.max(
        scrollHeight - viewportHeight,
        0
      );

      var progress =
        maxScroll > 0
          ? scrollTop / maxScroll
          : 0;

      progress = Math.min(
        1,
        Math.max(0, progress)
      );

      if (
        Math.abs(progress - lastProgress) <
        0.0001
      ) {
        return;
      }

      lastProgress = progress;

      stack.style.setProperty(
        "--auros-scroll-progress",
        progress.toFixed(5)
      );

      AUROS.scrollProgress.value = progress;
    }

    function requestProgressUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(
        measureProgress
      );
    }

    AUROS.scrollProgress =
      AUROS.scrollProgress || {};

    AUROS.scrollProgress.value = 0;
    AUROS.scrollProgress.refresh =
      requestProgressUpdate;

    window.addEventListener(
      "scroll",
      requestProgressUpdate,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      requestProgressUpdate,
      { passive: true }
    );

    window.addEventListener(
      "pageshow",
      requestProgressUpdate
    );

    window.addEventListener(
      "load",
      requestProgressUpdate,
      { once: true }
    );

    [
      "shopify:section:load",
      "shopify:section:unload",
      "shopify:section:reorder"
    ].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        requestProgressUpdate
      );
    });

    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(
        requestProgressUpdate
      );

      if (document.body) {
        resizeObserver.observe(document.body);
      }

      AUROS.scrollProgress.resizeObserver =
        resizeObserver;
    }

    requestProgressUpdate();
  }

  function initializeProductFlowContext() {
    initializeScrollProgress();

    var context = readProductFlowContext();

    installPublicApi(context);
    publishReadyEvent(context);

    /*
      Registrar WebMCP después de instalar la API pública garantiza que la
      herramienta siempre consulte la misma verdad estructurada de AUROS.
      La promesa se gestiona internamente y nunca bloquea el storefront.
    */
    registerPurchaseContextTool();
  }

  /*
    auros-custom.js se carga con defer desde theme.liquid, por lo que
    normalmente el documento ya fue parseado por completo cuando este código
    se ejecuta. Este respaldo mantiene el comportamiento correcto si en el
    futuro cambia la forma de carga del asset.
  */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeProductFlowContext,
      { once: true }
    );
  } else {
    initializeProductFlowContext();
  }
})();